import { ThemeService } from '@app/app-initialisers/theme-service/theme.service';

export const ThemeServiceInit = (themeService: ThemeService) => () => themeService.loadTheme();
